<dx-popover
    [target]="target"
    [showTitle]="true"
    [showCloseButton]="false"
    [closeOnOutsideClick]="false"
    [minWidth]="275"
    [minHeight]="100"
    (onShown)="onShown.emit($event)"
    (onHidden)="onHidden.emit($event)"
>
    <dxo-position>
        <dxo-at x="top" y="center"></dxo-at>
        <dxo-my x="bottom" y="center"></dxo-my>
        <dxo-offset x="-6" y="-40"></dxo-offset>
        <dxo-collision x="none" y="none"></dxo-collision>
    </dxo-position>
    <div *dxTemplate="let data of 'title'" class="popover-title">
        <strong class="popover-title-text center-aligned">
            <app-property-community-link
                *ngIf="popover?.visible"
                [communityId]="selectedCommunity?.communityId"
                [displayText]="selectedCommunity?.communityName"
            ></app-property-community-link>
        </strong>
        <i class="popover-title-icon cc-hyperlink" aria-hidden="true" [ngClass]="iconCross" (click)="hide()"></i>
    </div>
    <div *dxTemplate="let data of 'content'" class="align-items-center">
        <dx-form
            *ngIf="!!editorParams"
            width="100%"
            height="100%"
            labelLocation="left"
            [showColonAfterLabel]="false"
            [colCount]="1"
            [formData]="editorParams"
        >
            <dxi-item itemType="group" [colCount]="1" [visible]="!showCoordinatesEditor">
                <dxi-item>
                    <dxo-label [visible]="false"></dxo-label>
                    <div *dxTemplate class="center-aligned">
                        <span>
                            Latitude:&nbsp;
                            <strong>{{ selectedCommunity?.latitude }}</strong>
                        </span>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxo-label [visible]="false"></dxo-label>
                    <div *dxTemplate class="center-aligned">
                        <span>
                            Longitude:&nbsp;
                            <strong>{{ selectedCommunity?.longitude }}</strong>
                        </span>
                    </div>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="1" [visible]="showCoordinatesEditor">
                <dxi-item>
                    <dxo-label [visible]="false"></dxo-label>
                    <div *dxTemplate class="center-aligned bordered-top dx-theme-border-color">
                        <strong class="popover-title-text">Edit Coordinates</strong>
                    </div>
                </dxi-item>
                <dxi-item dataField="latitude" [isRequired]="true" editorType="dxNumberBox">
                    <dxo-label text="Latitude"></dxo-label>
                </dxi-item>
                <dxi-item dataField="longitude" [isRequired]="true" editorType="dxNumberBox">
                    <dxo-label text="Longitude"></dxo-label>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item
                        itemType="button"
                        horizontalAlignment="left"
                        verticalAlignment="center"
                        [buttonOptions]="{
                            type: 'default',
                            text: 'Cancel',
                            hint: 'Cancel',
                            icon: iconCancel,
                            onClick: onCancelClick
                        }"
                    ></dxi-item>
                    <dxi-item
                        itemType="button"
                        horizontalAlignment="right"
                        verticalAlignment="center"
                        [buttonOptions]="{
                            type: 'success',
                            text: 'Save',
                            hint: 'Save',
                            icon: iconSave,
                            onClick: onSaveClick
                        }"
                    ></dxi-item>
                </dxi-item>
            </dxi-item>
            <dxi-item
                itemType="button"
                horizontalAlignment="center"
                verticalAlignment="center"
                [visible]="!showCoordinatesEditor && !!selectedCommunity?.communityInfo"
                [buttonOptions]="{
                    type: 'default',
                    icon: iconEdit,
                    text: 'Edit Coordinates',
                    hint: 'Edit Map Coordinates',
                    onClick: onEditClick
                }"
            ></dxi-item>
        </dx-form>
    </div>
</dx-popover>
